import {
  Animatespin,
  SearchbarCom,
  SidenavbarCom,
  HireRequestsTable,
  Pagination,
} from "../../components";
import { IoClose } from "react-icons/io5";
import Icons from "../../assets/icon";
import { IoIosArrowRoundBack } from "react-icons/io";
import Functions from "./index.function";
export default function HireRequest() {
  const {
    setActiveTab,
    setCurrentPage,
    activeTab,
    hireRequests,
    isLoading,
    has_more_pages,
    total_pages,
    currentPage,
    formatDate,
    handleStartChat,
    setValueHiringRequests,
    valueHiringRequests,
    showPopup,
    setShowPopup,
    acceptpopup,
    setAcceptpopup,
    rejectpopup,
    setRejectpopup,
    approvedRequests,
    setApprovedRequests,
    popupApprovedRequests,
    setPopupApprovedRequests,
  } = Functions();
  return (
    <div className=" sm:h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 scroll-container h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 pt-2 pb-1 h-full`}>
            <div className="flex flex-col relative w-full h-full bg-[#1A1A1A] xs:px-2 sm:px-3 lg:px-5 rounded-lg">
              <div className="flex items-center justify-between py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-lg font-onestSemiBold xl:text-3xl">
                  Hire Requests
                </h1>
                <div className="flex items-center bg-[#2A2A2A] xs:gap-x-1 gap-x-2 p-1 rounded-full">
                  <button
                    onClick={() => {
                      setActiveTab("pending");
                      setCurrentPage(1);
                    }}
                    type={"button"}
                    className={`group xs:w-18 xs:h-8 sm:w-32 sm:h-10 lg:w-40 ${
                      activeTab === "pending" ? `gradient-container_btn` : ""
                    } xl:w-44 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                  >
                    <p
                      className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                    >
                      Pending Requests
                    </p>
                  </button>
                  <button
                    onClick={() => {
                      setActiveTab("approved");
                      setCurrentPage(1);
                    }}
                    type={"button"}
                    className={`group xs:w-18 xs:h-8 sm:w-32 sm:h-10 lg:w-40 ${
                      activeTab === "approved" ? `gradient-container_btn` : ""
                    } xl:w-44 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                  >
                    <p
                      className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                    >
                      Approved Requests
                    </p>
                  </button>
                  <button
                    onClick={() => {
                      setActiveTab("rejected");
                      setCurrentPage(1);
                    }}
                    type={"button"}
                    className={`group xs:w-18 xs:h-8 sm:w-32 sm:h-10 lg:w-40 ${
                      activeTab === "rejected" ? `gradient-container_btn` : ""
                    } xl:w-44 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                  >
                    <p
                      className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                    >
                      Rejected Requests
                    </p>
                  </button>
                </div>
              </div>
              <div className="flex-1 overflow-y-auto scroll-container">
                {isLoading === true ? (
                  <div className="xs:pt-1 sm:pt-2 lg:pt-3">
                    <Animatespin />
                  </div>
                ) : (
                  <>
                    {activeTab === "pending" && (
                      <div className="">
                        <HireRequestsTable
                          title={[
                            "Project name",
                            "Description",
                            "Project Budget",
                            "Duration",
                            "Start Date",
                          ]}
                          data={hireRequests?.hire_me}
                          setValueHiringRequests={setValueHiringRequests}
                          setShowPopup={setShowPopup}
                          requestTitle={"pending"}
                        />
                      </div>
                    )}
                    {activeTab === "approved" && (
                      <div className="">
                        <HireRequestsTable
                          title={[
                            "Project name",
                            "Description",
                            "Project Budget",
                            "Duration",
                            "Start Date",
                            "Action",
                          ]}
                          data={hireRequests?.hire_me}
                          setShowPopup={setShowPopup}
                          handleStartChat={handleStartChat}
                          setApprovedRequests={setApprovedRequests}
                          setPopupApprovedRequests={setPopupApprovedRequests}
                          requestTitle={"approved"}
                        />
                      </div>
                    )}
                    {activeTab === "rejected" && (
                      <div className="">
                        <HireRequestsTable
                          title={[
                            "Project name",
                            "Description",
                            "Project Budget",
                            "Duration",
                            "Start Date",
                            "",
                          ]}
                          data={hireRequests?.hire_me}
                          setValueHiringRequests={setValueHiringRequests}
                          setShowPopup={setShowPopup}
                          requestTitle={"rejected"}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              {acceptpopup && (
                <div className="fixed top-0 left-0 w-full h-screen flex justify-center items-center xs:p-5 sm:p-10 z-40">
                  <div className="xs:w-[80%] sm:w-[45%] lg:w-[35%] 2xl:w-[26%] xl:w-1/3 bg-[#0F0F0F] xs:p-5 sm:py-5 sm:px-3 h-auto relative rounded-3xl">
                    <div className="flex justify-end items-center">
                      <button
                        className="group xs:mb-4 sm:mb-5 lg:mb-5 bg-[#3D3D3D] xs:text-sm xs:w-5 xs:h-5 sm:w-5 sm:h-5 sm:text-xl lg:text-2xl lg:w-7 lg:h-7 rounded-full text-secondary flex justify-center items-center transform transition-transform duration-300 hover:scale-110"
                        onClick={() => setAcceptpopup(false)}
                      >
                        <IoClose className=" transform transition-transform duration-300 group-hover:rotate-180 xs:text-xs sm:test-sm lg:text-lg" />
                      </button>
                    </div>
                    <img
                      src={Icons.requestApprovedIcon}
                      alt="accept"
                      className="xs:w-20 xs:h-20 sm:w-36 sm:h-36 w-40 h-40 mx-auto"
                    />
                    <div className="flex justify-center items-center flex-col xs:pt-5 sm:pt-7 lg:pt-10">
                      <div className="text-center lg:pb-7 xl:pb-10">
                        <h2 className="text-secondary font-unboundedBold xs:text-sm sm:text-lg lg:text-xl xl:text-2xl">
                          REQUEST APPROVED
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {rejectpopup && (
                <div className="fixed top-0 left-0 w-full h-screen flex justify-center items-center xs:p-5 sm:p-10 z-40">
                  <div className="xs:w-[80%] sm:w-[45%] lg:w-[35%] 2xl:w-[26%] xl:w-1/3 bg-[#0F0F0F] xs:p-5 sm:py-5 sm:px-3 h-auto relative rounded-3xl">
                    <div className="flex justify-end items-center">
                      <button
                        className="group xs:mb-4 sm:mb-5 lg:mb-5 bg-[#3D3D3D] xs:text-sm xs:w-5 xs:h-5 sm:w-5 sm:h-5 sm:text-xl lg:text-2xl lg:w-7 lg:h-7 rounded-full text-secondary flex justify-center items-center transform transition-transform duration-300 hover:scale-110"
                        onClick={() => setRejectpopup(false)}
                      >
                        <IoClose className=" transform transition-transform duration-300 group-hover:rotate-180 xs:text-xs sm:test-sm lg:text-lg" />
                      </button>
                    </div>
                    <img
                      src={Icons.requestRejectedIcon}
                      alt="accept"
                      className="xs:w-20 xs:h-20 sm:w-36 sm:h-36 w-40 h-40 mx-auto"
                    />
                    <div className="flex justify-center items-center flex-col xs:pt-5 sm:pt-7 lg:pt-10">
                      <div className="text-center lg:pb-7 xl:pb-10">
                        <h2 className="text-secondary font-unboundedBold xs:text-sm sm:text-lg lg:text-xl xl:text-2xl">
                          REQUEST REJECTED
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* Popup Modal */}
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-2 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-screen ${
                  showPopup ? "translate-x-0" : "translate-x-full"
                } transition-transform duration-300 ease-in-out`}
              >
                <div className="flex justify-center items-start flex-col">
                  <div
                    className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                    onClick={() => setShowPopup(false)}
                  >
                    <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                    <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                      Back
                    </p>
                  </div>
                  <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                    <h2 className="text-secondary  font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-3xl">
                      Hire Request
                    </h2>
                  </div>
                  <div className="xs:px-2 sm:px-4 lg:px-5 w-full">
                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Project name:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valueHiringRequests?.project_title}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Project Budget:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valueHiringRequests?.budget}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                      <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Description
                        </p>
                      </div>
                      <div className="xs:max-h-[120px] sm:max-h-[200px] custom-scrollbar overflow-y-scroll">
                        <p
                          className="html-container font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                          dangerouslySetInnerHTML={{
                            __html: valueHiringRequests?.description,
                          }}
                        />
                      </div>
                    </div>

                    <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Duration:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {valueHiringRequests?.duration}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Start Date:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {formatDate(valueHiringRequests?.start_date)}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-2 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-screen ${
                  popupApprovedRequests ? "translate-x-0" : "translate-x-full"
                } transition-transform duration-300 ease-in-out`}
              >
                <div className="flex justify-center items-start flex-col relative">
                  <div
                    className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                    onClick={() => setPopupApprovedRequests(false)}
                  >
                    <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                    <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                      Back
                    </p>
                  </div>
                  <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                    <h2 className="text-secondary  font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-2xl">
                      Approved Hire Request
                    </h2>
                  </div>
                  <div className="xs:px-2 sm:px-4 lg:px-5 w-full">
                    <div className="flex xs:py-2 justify-between w-full sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Project name:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {approvedRequests?.project_title}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Project Budget:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {approvedRequests?.budget}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                      <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Description
                        </p>
                      </div>
                      <div className="xs:max-h-[120px] sm:max-h-[200px] custom-scrollbar overflow-y-scroll">
                        <p
                          className="html-container font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                          dangerouslySetInnerHTML={{
                            __html: approvedRequests?.description,
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex xs:py-2 justify-between w-full sm:py-3 lg:py-4">
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                          Duration:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {approvedRequests?.duration}
                          </span>
                        </p>
                      </div>
                      <div>
                        <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                          Start Date:
                          <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                            {formatDate(approvedRequests?.start_date)}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-2.5 pb-5 sm:pt-5 sm:pb-10">
                {hireRequests?.total_records > 10 && (
                  <div className="flex justify-end items-center">
                    <Pagination
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      total_pages={total_pages}
                      has_more_pages={has_more_pages}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
